import React from 'react'
import { Link } from 'react-router-dom'

import { Button } from '@/components/ui-compat'
import { useTranslation } from 'react-i18next'

const Page404 = () => {
  const { t } = useTranslation()
  return (
    <div className="text-center">
      <h1 className="text-6xl font-light">404</h1>
      <p className="text-4xl font-bold">{t('Page404_heading')}</p>
      <p className="text-2xl font-normal mt-3 mb-4">{t('Page404_subheading')}</p>
      <Link to="/">
        <Button color="primary" size="lg">
          {t('Page404_return_to_website_btn')}
        </Button>
      </Link>
    </div>
  )
}
export default Page404
